export default "__VITE_ASSET__BP$fyHkw__"